import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { RootState } from "../../app/store";
import { TStatus } from "../types";

interface IInitialState {
  preloaderStatus: boolean;
  errors: string[];
  status: TStatus;
  hasFirstInteract: boolean;
}

const initialState: IInitialState = {
  preloaderStatus: false,
  errors: [],
  status: "idle",
  hasFirstInteract: false,
};

export const slice = createSlice({
  name: "appSettings",
  initialState,

  reducers: {
    setPreloaderStatus: (state, action: PayloadAction<boolean>) => {
      state.preloaderStatus = action.payload;
    },
    setAppError: (state, action: PayloadAction<string>) => {
      const newErrors = state.errors.slice();
      newErrors.push(action.payload);
      state.errors = newErrors;
    },
    setFirstInteract: (state, action: PayloadAction<boolean>) => {
      state.hasFirstInteract = action.payload;
    },
  },
});

export const { setPreloaderStatus, setAppError, setFirstInteract } =
  slice.actions;

export const appPreloaderStatusState = (state: RootState) =>
  state.appSettings.preloaderStatus;

export const appHasFirstInteractState = (state: RootState) =>
  state.appSettings.hasFirstInteract;

const appSettingsReducer = slice.reducer;
export default appSettingsReducer;
